module.exports = __webpack_public_path__ + "media/img/vca/categories/intimate-fb148a7c399b04163b03ee1d4e5d3498.png";